import { BottomFillIcon, CheckedFillIcon, CircleIcon, RoundIcon, TopFillIcon } from "@t8891/icon";
import { Button, Input } from "@t8891/pc";
import { useSetState } from "ahooks";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { findRegionName } from "../../utils/helper";

const SelectItem = styled.div`
  .ant-select-selector {
    border-color: #e8e8e8 !important;
    padding-right: 0px !important;
  }
`;

export const SelectSexItem: React.FC<any> = ({ selected, setParams }) => {
  return (
    <div>
      <div className='text-14 mb-8 font-[500]'>您的性別</div>
      <div id={"SelectSexItem"} className='flex gap-24 text-16'>
        <div className='flex gap-8 cursor-pointer' onClick={() => setParams({ sex: 1 })}>
          {selected === 1 ? <CheckedFillIcon size={17} fill='#3264FF' /> : <RoundIcon size={17} />} 男
        </div>
        <div className='flex gap-8 cursor-pointer' onClick={() => setParams({ sex: 2 })}>
          {selected === 2 ? <CheckedFillIcon size={17} fill='#3264FF' /> : <RoundIcon size={17} />} 女
        </div>
      </div>
    </div>
  );
};

export const AdAgeItem: React.FC<any> = ({ data, selected = "41-50歲", setParams }) => {
  return (
    <div id={"AdAgeItem"}>
      <div className='text-14 mb-10 font-[500]'>您的年齡</div>
      <SelectItem>
        <Select
          value={selected}
          size='large'
          fieldNames={{ label: "name", value: "value" }}
          style={{ width: "100%", borderRadius: "4px", fontSize: "14px" }}
          suffixIcon={<BottomFillIcon size={32} fill='#818181' className='relative top-2 left-6' />}
          onChange={(value) => {
            setParams({ age: value });
          }}
          options={data}
        />
      </SelectItem>
    </div>
  );
};

export const AdEmailItem: React.FC<any> = ({ value, setParams }) => {
  return (
    <div id={"AdEmailItem"}>
      <div className='text-14 mb-10 font-[500]'>您的郵箱</div>
      <input
        style={{ fontSize: "14px", height: "40px", width: "100%", borderRadius: "4px", border: "1px solid #e8e8e8" }}
        className='pl-10 placeholder:text-[#BBB]'
        placeholder='請填寫您的E-mail'
        onChange={(e) => {
          setParams({ email: e.target.value });
        }}
      />
    </div>
  );
};

const RegionItem: React.FC<any> = ({ visible, region, setVisible, dataSource, onSelectIndex }) => {
  const regionName = findRegionName({ regionId: region, data: dataSource });

  return (
    <div className=''>
      <div
        id='RegionItem'
        className='w-80 pl-8 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14 cursor-pointer h-40 leading-32 bg-white'
        data-value={regionName}
        style={{ color: regionName.includes("請選擇") ? "#bbb" : "#333" }}
        onClick={() => {
          setTimeout(() => {
            setVisible(1);
          }, 10);
        }}
      >
        {regionName}
        <div className='absolute right-4 flex flex-col item-center'>
          <BottomFillIcon fill='#818181' size={32} />
          {/* {visible === 1 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />} */}
        </div>
      </div>
      {visible === 1 && Object.keys(dataSource).length !== 0 && (
        <section
          className='min-w-200 bg-[#fff] rounded-4 border-solid border-[#e8e8e8] text-[#333] text-14 pt-14 px-18 top-34 left-0  absolute text-left'
          style={{ boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)", zIndex: 1 }}
        >
          {dataSource?.map((v, i: number) => (
            <div className='mb-20 flex' key={i}>
              <label className='inline-block w-40 font-black'>{v.name}</label>
              <ul className='whitespace-pre inline-block font-normal text-[#999] cursor-pointer hover:text-[#3264ff]'>
                {Array.isArray(v.items) &&
                  v.items.map((vv: any, ii: number) => (
                    <li
                      id='region-item'
                      className={`inline-block font-normal ${
                        regionName === vv.name ? "text-[#3264ff]" : "text-[#999] "
                      } ml-20 cursor-pointer hover:text-[#3264ff]`}
                      key={ii}
                      onClick={() => {
                        onSelectIndex({
                          value: vv.value,
                          name: vv.name,
                        });
                      }}
                    >
                      {vv.name}
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

const DealerItem: React.FC<any> = ({ visible, setVisible, dataSource, regionId, dealer, onSelectIndex }) => {
  let dealerName = dealer || "請選擇縣市";

  return (
    <div>
      <div
        className='w-[254px] pl-10 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14 cursor-pointer h-40 leading-32 bg-white'
        id='DealerItem'
        data-value={dealerName}
        style={{ color: dealerName.includes("請選擇") ? "#bbb" : "#333" }}
        onClick={() => {
          setTimeout(() => {
            setVisible(2);
          }, 10);
        }}
      >
        {dealerName}
        <div className='absolute right-4 flex flex-col item-center'>
          <BottomFillIcon fill='#818181' size={32} />
          {/* {visible === 2 ? <TopFillIcon size={32} /> : <BottomFillIcon size={32} />} */}
        </div>
      </div>
      {visible === 2 && Object.keys(dataSource).length !== 0 && (
        <section
          className='bg-[#fff] rounded-4 border-solid border-[#e8e8e8] text-[#333] text-14 pt-20 px-18 top-30 left-100  absolute text-left'
          style={{ boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)", zIndex: 1 }}
        >
          {dataSource[regionId]?.map((v, i: number) => (
            <div className='mb-20' key={i}>
              <div
                id='dealer-item'
                onClick={() => {
                  onSelectIndex({
                    value: v.value,
                    name: v.name,
                  });
                }}
                className={`inline-block font-normal ${
                  dealerName === v.name ? "text-[#3264ff]" : "text-[#999] "
                } cursor-pointer hover:text-[#3264ff]`}
              >
                {v.name}
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export const AdRegionItem: React.FC<any> = ({ dataRegion, dealerSelected, dealers, region, setParams }) => {
  const [visible, setVisible] = useState<number>(0);

  useEffect(() => {
    document.addEventListener("click", function (event) {
      setVisible(0);
    });
  }, []);

  return (
    <div id={"AdRegionItem"}>
      <div className='text-14 mb-10 font-[500]'>您選擇的展示中心</div>
      <div className='text-center flex text-14 h-40  leading-90 relative rounded-4 gap-10'>
        <RegionItem
          dataSource={dataRegion.items}
          visible={visible}
          region={region}
          setVisible={setVisible}
          onSelectIndex={({ name, value }) => {
            const dealerName = dealers.items[value][0].name;

            setTimeout(() => {
              setVisible(2);
            }, 10);
            setParams({
              dealer: dealerName,
              region: value,
            });
          }}
        />
        <DealerItem
          dataSource={dealers.items}
          visible={visible}
          regionId={region}
          dealer={dealerSelected}
          setVisible={setVisible}
          onSelectIndex={({ name, value }) => {
            setVisible(0);
            setParams({
              dealer: value,
            });
          }}
        />
      </div>
    </div>
  );
};

export const Crumbs: React.FC<{ brandName?: string; kindName?: string; kindId?: number }> = ({
  brandName,
  kindName,
  kindId,
}) => {
  return (
    <div className='text-black text-14 py-20 flex'>
      您當前的位置：
      <div className='text-black'>新車首頁</div>
      {">"}
      <a href='/Models' className='text-black'>
        車款
      </a>
      {">"}
      <a href={`https://c.8891.com.tw/Models/${brandName}`} className='text-black'>
        {brandName}
      </a>
      {">"}
      <a href={`https://c.8891.com.tw/photoModel-info.html?k=${kindId}`} className='text-black'>
        {" "}
        {kindName}
      </a>
      {">"}
      車款詢價
    </div>
  );
};
